export const version = '0.3.18';
//# sourceMappingURL=version.js.map